import { Outlet } from "react-router-dom";
import Header from "../components/header";
import AuthGuard from "./AuthGuard";
import FooterV2 from "../components/FooterV2";
import { Roles } from "../constants";

function GuestRoutes() {
  return (
    <>
      <AuthGuard role={Roles.GUEST}>
        <Header />
        <Outlet />
        <FooterV2 />
      </AuthGuard>
    </>
  );
}
export default GuestRoutes;
